module.exports = __webpack_public_path__ + "media/POPULAR_Career_v6.96b453af.mp4";